import React from "react";
import { connect } from "react-redux";
import ReCompra2 from "../../components/Compras/ReCompra";
import LoadingScreen from "react-loading-screen";
import logo from "assets/img/logo/logo_aig_login-2.png";
import Page from "../../components/Page";
import Steps from "../../components/Generales/Steps";
import { Row, Col, Alert, } from "reactstrap";
import { FetchDataBancosCuotas, FetchDataRecompraPaquete, limpiarDatosRecompra } from "../../redux/actions/APolizas";
import { limpiarDatosEnvio, listarAccesoriosFetch } from "../../redux/actions/aCotizacion";

class ContainerReCompra extends React.Component {
  constructor(props) {
    props.limpiarRecompra()
    super(props);



  }

  async componentDidMount() {

    this.props.listarAccesorios();
    this.props.limpiarEnvio()
    const queryParams = new URLSearchParams(this.props.location.search);
    const idCarrito = queryParams.get('id');

    let objetoRecompraVacio = {
      "datosAccesorios": {
        "accesorios": [
        ],
        "valorAccesorios": "0"
      }
    }
    await this.props.listarRecompra(idCarrito, null, null, objetoRecompraVacio);
    await this.props.listarBancosCuotas();
   

  }


  render() {
    const queryParams = new URLSearchParams(this.props.location.search);
    const idCarrito = queryParams.get('id');

    return (
      <main class="cr-app bg-light">
        <div class="cr-content container-fluid">
          <div className="container-body-spaces">

            <LoadingScreen
              loading={
                this.props.datosRecompra.isLoading ||
                this.props.datosBancosCuotas.isLoading
              }

              bgColor="#f1f1f1"
              spinnerColor="#001871"
              textColor="#676767"
              logoSrc={logo}
              text="Obteniendo datos..."
            >


              <Page
                breadcrumbs={[{ name: "Recompra paquete kilómetros", active: true }]}
              >

                <Row>
                  <Col lg={8} md={12} sm={12} xs={12}>
                    <Steps tipo={'recompra'} activo={'cotizacion'}></Steps>

                  </Col>
                </Row>


                <Alert
                    color="warning"
                    isOpen={(this.props.datosRecompra.recompraPaquete == null)}
                >
                    <center>
                        <p>
                            {this.props.datosRecompra.recompraPaqueteError}
                        </p>
                    </center>
                </Alert>

               

                {this.props.datosRecompra.recompraPaquete != null && this.props.datosBancosCuotas.bancosCuotas && <ReCompra2
                  datosRecompra={this.props.datosRecompra.recompraPaquete}
                  datosBancos={this.props.datosBancosCuotas.bancosCuotas}
                  idPoliza={idCarrito}

                />

                }



              </Page>



            </LoadingScreen>



          </div>
        </div>
      </main>
    );
  }
}

const mapStateToProps = (state) => ({

  datosRecompra: state.dataRecompraPaquete,
  datosBancosCuotas: state.dataBancosCuotas,
});

const mapDispatchToProps = (dispatch) => {
  return {

    listarRecompra: (idPoliza, plan, suma, datosAccesorios) => dispatch(FetchDataRecompraPaquete(idPoliza, plan, suma, datosAccesorios)),
    listarBancosCuotas: () => dispatch(FetchDataBancosCuotas()),
    limpiarRecompra: () => dispatch(limpiarDatosRecompra()),
    limpiarEnvio: () => dispatch(limpiarDatosEnvio()),
    listarAccesorios: () => dispatch(listarAccesoriosFetch()),
  };
};

export default
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(ContainerReCompra)